import type { Channel } from "@/api/__generated__/models/channel";
import { ChannelReviewStatus } from "@/api/__generated__/models/channelReviewStatus.ts";
import { cn } from "@/lib/utils";
import { Button, Icon, Skeleton, Thumbnail, ThumbnailImage, Typography } from "@backpac/monica";

interface ChannelItemProps {
  channel: Channel;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

export const ChannelItem = ({ channel, selected, className, onClick }: ChannelItemProps) => {
  return (
    <Button variant="ghost" onClick={onClick} className="whitespace-normal p-0">
      <div
        className={cn(
          "flex items-center justify-between px-3 gap-3 h-14 w-40 cursor-pointer rounded-xl shadow-standard bg-white box-content",
          selected && "border border-black",
          className,
          {
            "text-textSubtle cursor-not-allowed":
              channel.reviewStatus === ChannelReviewStatus.PENDING ||
              channel.reviewStatus === ChannelReviewStatus.UNVERIFIED,
          },
        )}
      >
        <Thumbnail className="size-8">
          <ThumbnailImage src={channel.profileImageUrl} alt={channel.name} />
        </Thumbnail>
        <Typography size="xs" weight={600} className="line-clamp-2 text-left leading-[1.2] flex-1">
          {channel.name}
        </Typography>
        {channel.reviewStatus === ChannelReviewStatus.PENDING ||
          (channel.reviewStatus === ChannelReviewStatus.UNVERIFIED && (
            <Icon name="pending" iconColor="colorOrange" className="size-3" />
          ))}
      </div>
    </Button>
  );
};

ChannelItem.Pending = () => <Skeleton.Base width={160} height={48} />;
